import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from 'src/app/reports/services/report.service';

@Pipe({
  name: 'internationalNumber'
})
export class InternationalNumberPipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
    private decimalPipe: DecimalPipe
  ){

  }

  transform(value: any): any {
    if (!value) {
      return '';
    }
    let ans: any = '';
    if (isNaN(value))
      return "Invalid Input"
    if (value >= 1000 && value <= 999999) {
      ans = this.decimalPipe.transform((value / 1000), '1.0-1') + this.translate.instant('thousand');
    } else if (value >= 1000000 && value <= 999999999) {
      ans = this.decimalPipe.transform((value / 1000000), '1.0-1') + this.translate.instant('million');
    } else if (value >= 1000000000 && value <= 999999999999) {
      ans = this.decimalPipe.transform((value / 1000000000), '1.0-1') + this.translate.instant('billion');
    } else {
      ans = this.decimalPipe.transform(value, '1.0-1') + ""
      if (ans.includes('.00')) ans = this.decimalPipe.transform((ans.split('.00')[0]), '1.0-1');
    }
    return ans;
  }

}
